import { render, staticRenderFns } from "./Payt.vue?vue&type=template&id=5c476b5d&"
import script from "./Payt.vue?vue&type=script&lang=js&"
export * from "./Payt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports